import { render, staticRenderFns } from "./QaFeedback.vue?vue&type=template&id=5f90b8c8"
import script from "./QaFeedback.vue?vue&type=script&lang=ts"
export * from "./QaFeedback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports